const characterImages = { 
  crying: require('../characters/crying.png'),
  disappointed: require('../characters/dissapointed.png'),
  littleSleepy: require('../characters/litlesleepy.png'),
  littleAngry: require('../characters/littleAngry.png'),
  littleSad: require('../characters/littleSad.png'),
  neutral: require('../characters/nuetral.png'),
  sad: require('../characters/sad.png'),
  smiling: require('../characters/smilling.png'),
  thinking: require('../characters/thinking.png'),
};


const useCharacters = () => {
  // Get image by emotion name
  const getCharacterImage = (emotion) => {
    return characterImages[emotion] || characterImages.neutral; // Fallback to neutral if emotion not found
  };

  // Get all character images as an array of { emotion, src }
  const getAllCharacters = () => {
    return Object.entries(characterImages).map(([emotion, src]) => ({
      emotion,
      src,
    }));
  };

  return {
    getCharacterImage,
    getAllCharacters,
    characterImages, // Expose raw paths if needed
  };
};

export default useCharacters;